import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { UserConfigurationService } from '../services/userconfiguration/user-configuration.service';

export const URL_VALIDATOR_ERROR_KEY: string = 'urlInvalid';
export const URL_MAX_LENGTH = 2048;

/**
 * Protocols the backend's SecureUrlValidator actually accepts (java.net.URL only
 * constructs URLs for its registered stream handlers). The browser's URL parser
 * accepts arbitrary schemes (javascript:, data:, tel:, blob:, ...), so without this
 * allowlist the frontend would pass values the backend later rejects.
 */
const ALLOWED_URL_PROTOCOLS: ReadonlySet<string> = new Set([
  'http:',
  'https:',
  'ftp:',
  'mailto:'
]);

export function secureUrlValidator(whitelistService: UserConfigurationService): ValidatorFn {

  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }
    const isValid = isValidUrl(
      control.value,
      whitelistService
        .getOrDefault(whitelistService.WHITELIST_APP_URL)
        ?.split(',')
        .map((url: string) => url.trim()),
    );
    return isValid ? null : { [URL_VALIDATOR_ERROR_KEY]: true };
  };
}

export function secureUrl(
  control: AbstractControl,
  _allowedUrls?: string[],
): ValidationErrors | null {
  const validationError: { [key: string]: boolean } = {};
  validationError[URL_VALIDATOR_ERROR_KEY] = true;
  // empty url is secure
  if (!control.value) return null;
  return isValidUrl(control.value, _allowedUrls) ? null : validationError;
}

export function isValidUrl(_url: string, _allowedUrls?: string[]): boolean {
  if (!_url) {
    return false;
  }

  const isUrlWhitelisted = _allowedUrls?.includes(_url);
  if (isUrlWhitelisted) {
    // immediately return true if URL is explicitly allowed (just the same logic as in backend)
    return true;
  }

  try {
    const targetUrl = new URL(_url);
    return ALLOWED_URL_PROTOCOLS.has(targetUrl.protocol);
  } catch (_error) {
    console.error('invalid url: ', _error);
    return false;
  }
}
